import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import LegalNoticeContentFromMarkdown from '../Components/Legal/LegalNoticeContentFromMarkdown';
import $ from 'jquery';

export default function LegalNotice() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/legal-notice',
    title: 'Legal Notice',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20],
      filename: 'legal-notice.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Legal Notice</title>
        <meta name="description" content="Legal notice and terms of use for DISGENET platform." />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/legal-notice" />
        <meta property="og:title" content="DISGENET: Legal Notice" />
        <meta property="og:description" content="Legal notice and terms of use for DISGENET platform." />
      </Helmet>
      <CommonHeader />

      <section>
        <link rel="canonical" href="/legal-notice" />
        <div className="container txt-contenido mr-20 mt-2 text-right">
          <button
            className="btn bg-light rounded-circle fa fa-print"
            onClick={downloadSummary}
            title="Download PDF"
          ></button>
        </div>
        <div className="container txt-contenido" id="printer">
          <LegalNoticeContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
